module.exports = __webpack_public_path__ + "img/0630.8e67417d.png";